import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {BrowseConfig} from "@core/bean/browse-config";



@Injectable({providedIn: 'root'})
export class BrowseService {

  private browseSource = new Subject<any>();

  browse$ = this.browseSource.asObservable();

  public open(config:BrowseConfig, onOk, onCancel?) {
    this.browseSource.next({
      config: config,
      onOk: onOk,
      onCancel: onCancel,
    });
  }


}
